import { Flex } from 'antd';

/**
 * Shared filter bar wrapper — consistent padding/background/border.
 * Wrap your filter form controls inside this.
 *
 * Usage:
 *   <FilterBar>
 *     <Input placeholder="Tìm kiếm..." />
 *     <Button type="primary">Tìm</Button>
 *   </FilterBar>
 */
export default function FilterBar({ children, style }) {
  return (
    <div style={{
      background: '#fff',
      borderBottom: '1px solid #F1F5F9',
      padding: '12px 24px',
      ...style,
    }}>
      <Flex gap={12} wrap="wrap" align="center">
        {children}
      </Flex>
    </div>
  );
}
